import { Notebook } from "lucide-react";
import { resolveAccentPaletteColor } from "~/lib/accentPalette";
import { cn } from "~/lib/utils";
import { PartialProject } from "~/services/projects";

interface ProjectIconProps {
  project?: PartialProject;
  size?: number;
  className?: string;
  title?: string;
}

export const ProjectIcon = ({ project, size = 24, className, title }: ProjectIconProps) => {
  const notebookSize = Math.round(size * 0.83);
  const accentColor = project
    ? resolveAccentPaletteColor(project.accent_color ?? undefined)
    : undefined;
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center",
        !project && "text-muted-foreground",
        className
      )}
      style={{ width: size, height: size }}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      <Notebook
        style={{ width: notebookSize, height: notebookSize }}
        color={accentColor?.fg ?? accentColor?.accent}
        fill={accentColor?.bg}
      />
    </div>
  );
};
